import { render, staticRenderFns } from "./WorkflowTriggers.vue?vue&type=template&id=7022fcf2&"
import script from "./WorkflowTriggers.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTriggers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports